import { gql } from '@apollo/client'

export const INIT_PAYMENT = gql`
  mutation initPayment($paymentInput: PaymentInputDto!, $capchaKey: String!) {
    initPayment(paymentInput: $paymentInput, capchaKey: $capchaKey)
  }
`
